import Dashboard from "../Pages/Parents/Dashboard/Dashboard";
import Profile from "../Pages/Profile/Profile";
import SchoolsListing from "../Pages/Common/Schools/SchoolsListing/SchoolsListing";
import ClassesAndCourses from "../Pages/Admin/ClassesAndCourses/ClassesAndCourses";
import CoursesListing from "../Pages/Admin/ClassesAndCourses/CoursesListing/CoursesListing";
import Attendance from "../Pages/Admin/Attendance/Attendance";
import PreviousAttendance from "../Pages/Admin/Attendance/PreviousAttendance/PreviousAttendance";
import ExamListing from "../Pages/Admin/ClassesAndCourses/Exams/ExamListing/ExamListing";
import ExamResult from "../Pages/Admin/Results/ExamResult/ExamResult";
import SportsListing from "../Pages/Common/Sports/SportsListing/SportsListing";
import RoomsListing from "../Pages/Common/Hostel/RoomsListing/RoomsListing";
import TransportsListing from "../Pages/Common/Transports/TransportsListing/TransportsListing";
import HolidaysListing from "../Pages/Common/Holidays/HolidaysListing/HolidaysListing";
import SchoolLibraryListing from "../Pages/Common/SchoolLibrary/SchoolLibraryListing/SchoolLibraryListing";
import { List, Users } from "react-feather";
import AllNotifications from "../Pages/Notifications/AllNotifications/AllNotifications";

export const ParentRoutes = [
  // Parent Routes

  // All Notifications
  {
    id: "parent_notifications_details",
    path: "/user/parent/all-notifications",
    title: "Parent Notifications",
    layout: "parent",
    parent: false,
    component: <AllNotifications />,
  },

  // Dashboard
  {
    id: "parent_dashboard",
    path: "/user/parent/dashboard",
    title: "Parent Dashboard",
    layout: "parent",
    parent: true,
    component: <Dashboard />,
    icon: <List />,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Profile
  {
    id: "parent_profile",
    path: "/user/parent/profile",
    title: "Parent Profile",
    layout: "parent",
    parent: false,
    component: <Profile />,
    icon: <Users size={18} />,
  },

  // Schools
  {
    id: "parent_schools_listing",
    path: "/user/parent/schools",
    title: "Schools",
    layout: "parent",
    parent: true,
    component: <SchoolsListing />,
    icon: <i className="fas fa-building"></i>,
    activeIcon: (
      <i className="fas fa-building" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Classes And Courses
  {
    id: "parent_classes_courses",
    path: "/user/parent/classes",
    title: "Classes And Courses",
    layout: "parent",
    parent: true,
    component: <ClassesAndCourses />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "parent_courses",
    path: "/user/parent/classes/details/*",
    title: "Courses",
    layout: "parent",
    parent: false,
    component: <CoursesListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Attendance
  {
    id: "parent_attendance_courses",
    path: "/user/parent/classes/courses/attendance/:id/:id",
    title: "",
    layout: "parent",
    parent: false,
    component: <Attendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "parent_attendance_courses",
    path: "/user/parent/classes/courses/attendance/details/",
    title: "",
    layout: "parent",
    parent: false,
    component: <PreviousAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Exams
  {
    id: "parent_exams",
    path: "/user/parent/classes/:id/courses/:id/exams",
    title: "Exams",
    layout: "parent",
    parent: false,
    component: <ExamListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Results
  {
    id: "parent_result_view",
    path: "/user/parent/classes/:id/courses/:id/exams/:id/result/:id",
    title: "View Result",
    layout: "parent",
    parent: false,
    component: <ExamResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Sports
  {
    id: "parent_school_sports",
    path: "/user/parent/sports",
    title: "Sports",
    layout: "parent",
    parent: true,
    component: <SportsListing />,
    icon: <Users size={18} />,
  },

  // Hostel
  {
    id: "parent_school_hostel",
    path: "/user/parent/hostel",
    title: "Hostel",
    layout: "parent",
    parent: true,
    component: <RoomsListing />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },

  // Transport
  {
    id: "parent_school_transport",
    path: "/user/parent/transport",
    title: "Transport",
    layout: "parent",
    parent: true,
    component: <TransportsListing />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },

  // Holidays
  {
    id: "parent_school_holidays",
    path: "/user/parent/holidays",
    title: "Holidays",
    layout: "parent",
    parent: true,
    component: <HolidaysListing />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Library
  {
    id: "parent_library_listing",
    path: "/user/parent/library",
    title: "Library",
    layout: "parent",
    parent: true,
    component: <SchoolLibraryListing />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
];
